
import React from "react";
import { TemplateList } from "./TemplateList";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import { Skeleton } from "@/components/ui/skeleton";
import { ReportTemplate } from "@/types/reportTypes";

interface Props {
  templates: ReportTemplate[];
  loading: boolean;
  error: string | null;
  selectedCategories: string[];
  setSelectedCategories: (v: string[]) => void;
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  reportCategories: string[];
  onSelectTemplate: (template: ReportTemplate) => void;
}

export const ReportTemplatesSidebar: React.FC<Props> = ({
  templates,
  loading,
  error,
  selectedCategories,
  setSelectedCategories,
  searchTerm,
  setSearchTerm,
  reportCategories,
  onSelectTemplate,
}) => {
  // Multiselect logic
  const handleCategoryChange = (cat: string) => {
    if (cat === "All Categories") {
      setSelectedCategories(["All Categories"]);
    } else {
      // Remove "All Categories" if selecting others
      let newSelection = selectedCategories.filter((c) => c !== "All Categories");
      if (selectedCategories.includes(cat)) {
        newSelection = newSelection.filter((c) => c !== cat);
      } else {
        newSelection = [...newSelection, cat];
      }
      if (newSelection.length === 0) newSelection = ["All Categories"];
      setSelectedCategories(newSelection);
    }
  };

  return (
    <div className="md:col-span-1 overflow-y-auto pr-2">
      <h3 className="font-medium mb-2">Report Templates</h3>
      {/* Search input */}
      <input
        type="search"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="Search templates..."
        className="block w-full mb-2 p-2 border rounded bg-background text-sm"
      />
      {/* Multi-category filter */}
      <div className="flex flex-wrap gap-2 mb-2">
        {reportCategories.map((category) => (
          <label key={category} className="flex items-center text-xs cursor-pointer gap-1">
            <input
              type="checkbox"
              checked={selectedCategories.includes(category)}
              onChange={() => handleCategoryChange(category)}
            />
            <span>{category}</span>
          </label>
        ))}
      </div>
      <ErrorBoundary componentName="TemplateList">
        {loading ? (
          <div className="space-y-2">
            {Array.from({ length: 4 }).map((_, idx) => (
              <Skeleton key={idx} className="rounded bg-muted p-3 h-20" />
            ))}
          </div>
        ) : error ? (
          <div className="text-destructive text-sm">{error}</div>
        ) : (
          <TemplateList templates={templates} onSelectTemplate={onSelectTemplate} />
        )}
      </ErrorBoundary>
    </div>
  );
};
